import { render, staticRenderFns } from "./Form10.vue?vue&type=template&id=57c0b713&"
import script from "./Form10.vue?vue&type=script&lang=js&"
export * from "./Form10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports